// Per-page SEO overrides set in the admin area, fetched once per visit.
// A page keeps whatever it sets for itself unless an override has been filled
// in, so this can only ever change a page deliberately.
import { useEffect, useState } from "react";
import { API } from "./api";

let cache = null;

function load() {
  if (!cache) {
    cache = fetch(`${API}/seo/overrides`)
      .then((r) => (r.ok ? r.json() : { overrides: {} }))
      .then((d) => d.overrides || {})
      .catch(() => ({}));
  }
  return cache;
}

export function useSeoOverride(path) {
  const [all, setAll] = useState(null);
  useEffect(() => {
    let live = true;
    load().then((o) => live && setAll(o));
    return () => {
      live = false;
    };
  }, []);
  if (!all) return null;
  return all[path] || all[path.replace(/\/$/, "")] || null;
}
